module.exports = __webpack_public_path__ + "img/ot-ausdc_usdc.494876d5.png";